import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { FRAGRANCES_LINKS } from '@banyan/commons/consts/links.const';
import { SimpleLink } from '@banyan/commons/models/simple-link.model';
import { AccountService } from '@banyan/modules/account/services/account.service';

@Component({
  selector: 'app-header-navbar',
  templateUrl: './header-navbar.component.html',
  styleUrls: ['./header-navbar.component.scss'],
})
export class HeaderNavbarComponent {
  @Output() sideNavToggle = new EventEmitter();
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  router = inject(Router);
  accountService = inject(AccountService);

  fragrancesLinks: SimpleLink[] = FRAGRANCES_LINKS;

  openSidenav() {
    this.sideNavToggle.emit(true);
  }

  goToLink(url: string, event: any): void {
    event.stopPropagation();
    this.menuTrigger.closeMenu();
    this.router.navigate([url]).then();
  }
}
